<template>
  <div class="px-4 sm:px-6 lg:px-8 py-4 sm:py-6 lg:py-8">
    <slot />
  </div>
</template>